import * as yup from 'yup';

export const schema = yup.object({
	dailyStudyIds: yup.array().of(yup.number().required()),
	suggestionIds: yup.array().of(yup.number().required()),
});

export type ValidationsSchemaType = yup.InferType<typeof schema>;
